import { Injectable, QueryList, ViewChildren } from "@angular/core";
import { IAssessmentExtended } from "@interfaces/index";
import { AppRoutingService, HttpService } from "@ui-components/services";
import { AssessmentService } from "./assessment.service";
import { AppService } from '@ui-components/services';
import { Router } from "@angular/router";
import { MatMenuTrigger } from "@angular/material/menu";


@Injectable({
    providedIn: 'root',
})
export class DashboardService {
	
	@ViewChildren(MatMenuTrigger) triggers!: QueryList<MatMenuTrigger>;
    
  constructor(
		protected _app_routing_service: AppRoutingService,
		protected _app_service: AppService,
    protected _assessment_service: AssessmentService,
    protected _http_service: HttpService,
		protected _router: Router,
  ) { }

  complete(assessment: IAssessmentExtended) {
    this._router.navigate(['/assessments', 'complete', assessment.access_token])
  }

	goToProfile() {
		this._app_routing_service.goToAssessments('profile');
	}

	view(assessment: IAssessmentExtended) {  
		this._router.navigate(['/report', assessment.org_person_assessment_id])
	}


}